import { verifyCaptcha, verifyCaptchaLawyers } from './captcha.api';
import { doctrineAnalytics } from '../utils/analyticsUtils';

const isLawyerPage = window.location.pathname.startsWith('/p/avocat/');
const isDecisionPage = window.location.pathname.startsWith('/d/');

export const getCaptchaSourcePageFromUrl = () => {
  if (isLawyerPage) {
    return 'Lawyer';
  }
  if (isDecisionPage) {
    return 'Decision';
  }
  return null;
};

export const captchaSuccess = async (gRecaptchaResponse: string | null) => {
  try {
    if (isLawyerPage) {
      await verifyCaptchaLawyers(gRecaptchaResponse);
    } else {
      await verifyCaptcha(gRecaptchaResponse);
    }
    const sourcePage = getCaptchaSourcePageFromUrl();
    doctrineAnalytics('Captcha CaptchaValidated', { sourcePage });
    window.location.reload();
  } catch (error) {
    window.location.reload();
    throw error;
  }
};
